export enum ErrorEvent {
  /** CoauthorGallery: The information received about the client is invalid */
  InvalidClientInfo = 'InvalidClientInfo',
  /** PermissionsPanel: Invalid response from Permissions API */
  GetPermissionsResponseError = 'GetPermissionsResponseError',
  /** Issues when making getUserPhoto call */
  GetUserPhotoError = 'GetUserPhotoError',
  /** ShareService did not load correctly */
  ShareServiceLoadError = 'ShareServiceLoadError',
  /** PermissionsPanel: when there are zero sharelinks associated with a fluid file */
  ZeroShareLinks = 'ZeroShareLinks'
}
